import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';   // ⬅️ primero el sistema de diseño global
import './index.css';   // ⬅️ luego tus ajustes específicos
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
